<script setup lang="ts">
import { computed } from "vue";

import { getAlmInfo } from "@/backend/read/BackendReader";
import ListEmpty from "@/components/ui/ComplexList/ListEmpty.vue";
import { cockpitConnectionUrl } from "@/components/utils/cockpitUrls";
import { useTeamStore } from "@/store/team";
import { useUserStore } from "@/store/user";

defineProps<{ message: string }>();

const canConfigureAlm = computed(() => useUserStore().isAllowed("configureAlm"));
const almInfo = computed(() => getAlmInfo());
const teamId = computed(() => useTeamStore().current.id);
</script>

<template>
  <ListEmpty :icon="almInfo.icon" tabindex="-1" aria-live="polite">
    <p>
      <!-- Message: no issues found -->
      {{ message }}
      <!-- Optional prompt to check config (for admins) -->
      <template v-if="canConfigureAlm">
        <br />
        {{ $t("issueSelector.message.checkConfig") }}
      </template>
    </p>
    <!-- Link to check config (for admins) -->
    <p v-if="canConfigureAlm" class="cockpit-link">
      <a :href="cockpitConnectionUrl(teamId)" target="_blank" rel="noopener noreferrer">
        {{ $t("issueSelector.configure") }}
      </a>
    </p>
  </ListEmpty>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.cockpit-link {
  color: colors.$text;
  margin-top: 8px;
}
</style>
